import { apiCall } from "./service";
import {
  URL_SP_AI_BULK_ANALYSE,
  URL_SP_AI_BULK_ANALYSE_ACTIVE,
  URL_SP_AI_BULK_ANALYSE_PREVIEW,
  URL_SP_AI_BULK_ANALYSE_DISMISS,
  URL_SP_AI_BULK_ANALYSE_RETRY,
  URL_SP_AI_BULK_ANALYSE_RUN,
  URL_SP_AI_BULK_ANALYSE_STOP,
} from "./URL";

/**
 * Bulk timesheet AI analyse — Laravel queues and runs the job, so these go
 * through the Laravel client, not aiClient.
 */
const preview = (payload) =>
  apiCall.post({
    url: URL_SP_AI_BULK_ANALYSE_PREVIEW,
    params: payload,
    isAuthToken: true,
    skipQueryParams: true,
  });

const create = (payload) =>
  apiCall.post({
    url: URL_SP_AI_BULK_ANALYSE,
    params: payload,
    isAuthToken: true,
    skipQueryParams: true,
  });

const active = () =>
  apiCall.get({ url: URL_SP_AI_BULK_ANALYSE_ACTIVE, isAuthToken: true });

const detail = ({ uuid, status = "all", page = 1, perPage = 10 }) => {
  const query = new URLSearchParams({
    status,
    page: String(page),
    per_page: String(perPage),
  });
  return apiCall.get({
    url: `${URL_SP_AI_BULK_ANALYSE_RUN(uuid)}?${query.toString()}`,
    isAuthToken: true,
    skipQueryParams: true,
  });
};

const stop = (uuid) =>
  apiCall.post({ url: URL_SP_AI_BULK_ANALYSE_STOP(uuid), params: {}, isAuthToken: true });

const retry = (uuid, scope = "all") =>
  apiCall.post({
    url: URL_SP_AI_BULK_ANALYSE_RETRY(uuid),
    params: { scope },
    isAuthToken: true,
    skipQueryParams: true,
  });

const dismiss = (uuid) =>
  apiCall.post({ url: URL_SP_AI_BULK_ANALYSE_DISMISS(uuid), params: {}, isAuthToken: true });

const api = { preview, create, active, detail, stop, retry, dismiss };

export default api;
